// InstallationConfiguration.js - Main entry point for Installation Configuration
// This component renders the tabbed interface for managing all installation-related data
import React, { useState } from 'react';
import { Box, Tabs, Tab } from '@mui/material';

// Import all tab components
import InstTypeTab from './InstTypeTab';
import InstExteriorTypeTab from './InstExteriorTypeTab';
import InstBrickmoldSizeTab from './InstBrickmoldSizeTab';
import InstBrickmoldColorTab from './InstBrickmoldColorTab';
import InstJambTypeTab from './InstJambTypeTab';
import InstInteriorCasingTab from './InstInteriorCasingTab';
import InstInteriorCasingSizeTab from './InstInteriorCasingSizeTab';

const InstallationConfiguration = () => {
  const [activeTab, setActiveTab] = useState(0);

  const tabs = [
    { label: 'Installation Type', component: <InstTypeTab /> },
    { label: 'Exterior Type', component: <InstExteriorTypeTab /> },
    { label: 'Brickmold Size', component: <InstBrickmoldSizeTab /> },
    { label: 'Brickmold Color', component: <InstBrickmoldColorTab /> },
    { label: 'Jamb Type', component: <InstJambTypeTab /> },
    { label: 'Interior Casing', component: <InstInteriorCasingTab /> },
    { label: 'Interior Casing Size', component: <InstInteriorCasingSizeTab /> },
  ];

  return (
    <Box sx={{ width: '100%' }}>
      <Tabs
        value={activeTab}
        onChange={(e, newValue) => setActiveTab(newValue)}
        sx={{ mb: 2 }}
        variant="scrollable"
        scrollButtons="auto"
      >
        {tabs.map((tab, index) => (
          <Tab key={index} label={tab.label} />
        ))}
      </Tabs>

      {tabs[activeTab]?.component}
    </Box>
  );
};

export default InstallationConfiguration;
